(function () {
  "use strict";

  var NOMINAL_MAP = {
    "16x25x1": [15.5, 24.5, 0.75],
    "16x20x1": [15.5, 19.5, 0.75],
    "20x20x1": [19.5, 19.5, 0.75],
    "20x25x1": [19.5, 24.5, 0.75],
    "16x25x4": [15.5, 24.5, 3.63]
  };

  function fitCheck(w, h, d, outEl) {
    if (!outEl) return;
    if (isNaN(w) || isNaN(h) || isNaN(d)) {
      outEl.textContent = "Please enter width, length, and depth in inches.";
      return;
    }
    var best = null;
    for (var key in NOMINAL_MAP) {
      if (!Object.prototype.hasOwnProperty.call(NOMINAL_MAP, key)) continue;
      var a = NOMINAL_MAP[key];
      var score = Math.abs(w - a[0]) + Math.abs(h - a[1]) + Math.abs(d - a[2]);
      if (!best || score < best.score) best = { nom: key, score: score };
    }
    if (best.score <= 0.5) {
      outEl.innerHTML = "Best match: <strong>" + best.nom + "</strong> (high confidence).";
    } else if (best.score <= 1.2) {
      outEl.innerHTML = "Closest match: <strong>" + best.nom + "</strong>. Double-check airflow direction and slot clearance.";
    } else {
      outEl.textContent = "Large deviation from common sizes. Contact support with a photo of your existing filter frame.";
    }
  }

  function initFitForm() {
    var btn = document.getElementById("fitCheckBtn");
    if (!btn) return;
    btn.addEventListener("click", function () {
      var w = parseFloat(document.getElementById("fitW").value);
      var h = parseFloat(document.getElementById("fitH").value);
      var d = parseFloat(document.getElementById("fitD").value);
      fitCheck(w, h, d, document.getElementById("fitResult"));
    });
  }

  function initReveal() {
    var els = document.querySelectorAll(".apx-reveal");
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.classList.add("visible");
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  function initPills() {
    document.querySelectorAll("[data-pill-group]").forEach(function (group) {
      group.querySelectorAll(".apx-pill").forEach(function (pill) {
        pill.addEventListener("click", function () {
          group.querySelectorAll(".apx-pill").forEach(function (node) {
            node.classList.remove("active");
          });
          pill.classList.add("active");
        });
      });
    });
  }

  window.ApexPuri = window.ApexPuri || {};
  window.ApexPuri.fitCheck = fitCheck;

  document.addEventListener("DOMContentLoaded", function () {
    initFitForm();
    initReveal();
    initPills();
  });
})();
